import { Checkbox, Form, Select } from 'antd';
import React from 'react';
import styles from '../rules.module.scss';
import { selectSearchFilter } from '@services/utils';

const { Option } = Select;

const VersionComparisonSection: React.FC<{
  type: 'fw' | 'ui' | 'loader';
  enabled: boolean;
  onToggle: () => void;
  versions?: Array<{ id: string; version: string }>;
  deviceTypeId?: string;
}> = ({ type, enabled, onToggle, versions, deviceTypeId }) => {
  const typeLabels = {
    fw: 'Fw',
    ui: 'Ui',
    loader: 'Loader',
  };

  const gridAreas = {
    fw: { enable: 'enableCompareFwVersions', min: 'fwVersionOne', max: 'fwVersionTwo' },
    ui: { enable: 'enableCompareUiVersions', min: 'uiVersionOne', max: 'uiVersionTwo' },
    loader: { enable: 'enableCompareLoaderVersions', min: 'loaderVersionOne', max: 'loaderVersionTwo' },
  };

  return (
    <>
      <Form.Item
        name={`enable${type === 'fw' ? 'Fw' : type === 'ui' ? 'Ui' : 'Loader'}Condition`}
        valuePropName="checked"
        className={styles.block}
        style={{ gridArea: gridAreas[type].enable }}
      >
        <Checkbox onChange={onToggle} checked={enabled}>
          Enable Compare {typeLabels[type]} Versions
        </Checkbox>
      </Form.Item>

      <Form.Item
        name={`min${typeLabels[type]}Version`}
        label={`Min ${typeLabels[type]} Version`}
        className={styles.block}
        style={{ gridArea: gridAreas[type].min }}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const enabledField = getFieldValue(`enable${typeLabels[type]}Condition`);
              if (enabledField && !value) {
                return Promise.reject(new Error(`Min ${typeLabels[type]} Version is required`));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Select disabled={!enabled} allowClear showSearch filterOption={selectSearchFilter}>
          {deviceTypeId &&
            versions?.map((item) => (
              <Option key={item.id} value={item.version}>
                {item.version}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        name={`max${typeLabels[type]}Version`}
        label={`Max ${typeLabels[type]} Version`}
        className={styles.block}
        style={{ gridArea: gridAreas[type].max }}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const enabledField = getFieldValue(`enable${typeLabels[type]}Condition`);
              if (enabledField && !value) {
                return Promise.reject(new Error(`Max ${typeLabels[type]} Version is required`));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Select disabled={!enabled} allowClear showSearch filterOption={selectSearchFilter}>
          {deviceTypeId &&
            versions?.map((item) => (
              <Option key={item.id} value={item.version}>
                {item.version}
              </Option>
            ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default VersionComparisonSection;
